import { Heading, Row } from '@stenajs-webui/core';
import { ModalBody, ModalCloseButton } from '@stenajs-webui/modal';
import { cssColor } from '@stenajs-webui/theme';
import { Suspense, useEffect } from 'react';
import { getGuid } from '../../../common/utils/guidUtils';
import { Loading } from '../../../common-ui/Loading';
import { useIntermodalVehicleTypesBackgroundQuery } from '../../../services/intermodal/hooks/useAllIntermodalVehicleTypesAsOptions';
import { useGoodsTypesBackgroundQuery } from '../../../services/intermodal/hooks/useGoodsTypes';
import { initializeIntermodalCreateThunk } from '../../../services/intermodal/thunks/initializeIntermodalCreateThunk';
import { useAppDispatch } from '../../../store/appDispatch';
import { IntermodalBookingCreate } from './IntermodalBookingCreate';
import { IntermodalCreateModalFooter } from './IntermodalCreateFooter';

interface IntermodalBookingCreateContainerProps {
  onClose: () => void;
}

export const IntermodalBookingCreateModalContainer = ({
  onClose,
}: IntermodalBookingCreateContainerProps) => {
  const dispatch = useAppDispatch();
  const goodsTypesQueryRef = useGoodsTypesBackgroundQuery();
  const vehicleTypesQueryRef = useIntermodalVehicleTypesBackgroundQuery();

  useEffect(() => {
    dispatch(initializeIntermodalCreateThunk({ goodId: getGuid() }));
  }, [dispatch]);

  return (
    <Suspense
      fallback={
        <ModalBody>
          <Loading />
        </ModalBody>
      }
    >
      <ModalBody maxWidth={1600}>
        <Row alignItems={'center'} justifyContent={'space-between'}>
          <Heading variant={'h3'} color={cssColor('--lhds-color-ui-900')} whiteSpace={'nowrap'}>
            Create intermodal booking
          </Heading>
          <ModalCloseButton onClick={onClose} aria-label={'Close'} />
        </Row>
        <IntermodalBookingCreate
          goodsTypesQueryRef={goodsTypesQueryRef}
          vehicleTypesQueryRef={vehicleTypesQueryRef}
        />
      </ModalBody>
      <IntermodalCreateModalFooter onClose={onClose} />
    </Suspense>
  );
};
